import { type FC, useContext } from "react";
import { type TableColumnMap, TableComponent } from "../../Forms/DragDrop/ComponentBases/TableComponent";
import { DragDropComponentErrorContext } from "../../Forms/DragDrop/DragDropComponent";
import { DragDropDataContext } from "../../Forms/DragDrop/DragDropRenderer";
import { type ComponentOptions } from "../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue } from "../../Forms/DragDrop/ReorderableTableSettings";

const INVOICE_COLUMNS: TableColumnMap = {
    "timestamp" : {},
    "invoice-id": {},
    "allocated" : {},
    "remaining" : {},
    "total"     : {},
};

export const ReceiptInvoiceTableComponent: FC<ComponentOptions> = ({ value, style }) => {
    const { invoices } = useContext(DragDropDataContext);

    const error = useContext(DragDropComponentErrorContext);

    if(!Array.isArray(invoices)) {
        return error;
    }

    if(!hasColumnsValue(value)) {
        return error;
    }

    return (
        <TableComponent
            columns={INVOICE_COLUMNS}
            data={invoices}
            value={value.columns}
            style={style}
        />
    );
};
